const getProductWithoutQuantity = products =>
	products.map(({ quantity = 0, cart_quantity = 0, ...product }) => ({ ...product }));

export default getProductWithoutQuantity;
